/**
 * Author : Hashan Eranda Jayalath
 * Copyrights: Hashan Eranda Jayalath
 * Version:
 * Description: Action type definitions
 * Date: 12-06-2020
 */

//menue
export const MENU_TOGGLE = "MENU_TOGGLE";
